import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("RazorPaginator")
export class RazorPaginator implements AxInit {
    constructor(
        private _axLoading = new AxLoading(),
        private initData: RazorPaginatorDto,
        private $parent: JQuery<Element>,
    ) {}

    AxInit(init: initData): void {
        this.initData = init.paginator;
        this.$getParent();

        this.$parent.on('click', '[data-paginator-page]', (e) => {
            if (this.initData.partialView) {
                const pageClicked = Number($(e.currentTarget).attr('data-paginator-page'));
                const data = {
                    Take: this.initData.take,
                    Page: pageClicked,
                };
                this.renderPage(data);
            }
        });

        this.$parent.on('click', '[data-paginator-navigation]', (e) => {
            if (this.initData.partialView) {
                const $clickedControl = $(e.currentTarget);
                const action = $clickedControl.attr('data-paginator-navigation');
                let pages = Math.floor(this.initData.total / this.initData.take);
                pages += (this.initData.total % this.initData.take) == 0 ? 0 : 1;
                const pageByAction = {
                    start: 0,
                    previous: this.getActivePage() - 1,
                    next: this.getActivePage() + 1,
                    end: pages - 1,
                }
                const data = {
                    Take: this.initData.take,
                    Page: pageByAction[action],
                };
                this.renderPage(data);
            }
        });
    }

    $getParent() {
        this.$parent = $('[data-paginator-component]');
    }

    getActivePage() {
        this.$getParent();
        const $activePage = this.$parent.find(`[data-paginator-page].active`);
        return Number($activePage.attr('data-paginator-page'));
    }

    renderPage(data: { Take: number, Page: number }) {
        this._axLoading.ShowLoadingIndicator($(this.initData.parentJQuerySelector)?.get(0));
        AxessViewer.loadPartialView(this.initData.partialView, data, (resp: { view: string }) => {
            const $parent = $(this.initData.parentJQuerySelector);
            if ($parent.length > 0 && resp.view !== '') {
                const parsedView = $.parseHTML(resp.view, true);
                $parent.html('').append(parsedView);
            }
        });
    }
}

interface initData {
    paginator: RazorPaginatorDto;
}

interface RazorPaginatorDto {
    total: number;
    page: number;
    take: number;
    bubblesToShow: number;
    partialView: string;
    parentJQuerySelector: string;
}